module.exports = __webpack_public_path__ + "static/media/17-5.9e3e0d30.mp3";